module.exports = __webpack_public_path__ + "static/media/shareios.aad8081d.svg";